import React from 'react';
import type { Tenant } from '@aurora/shared-types/tenant';

export default React.createContext<Tenant | null>(null);
